var map = {
	"./au.svg": "cda7",
	"./be.svg": "0fdc",
	"./br.svg": "0242",
	"./ca.svg": "b8b8",
	"./ch.svg": "c96c",
	"./de.svg": "d1062",
	"./fi.svg": "4bc0",
	"./gb.svg": "7878",
	"./hk.svg": "d320",
	"./id.svg": "f83d",
	"./nl.svg": "7363",
	"./sg.svg": "67f7",
	"./us.svg": "f1e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c1f5";